import React from 'react';
import Modal from 'components/utility/Modal/Modal';
import Button from 'components/elements/button';
import Box from 'components/elements/Box';
import P from 'components/elements/p';
import ListViewContainer from 'components/customlists/shared/ListViewContainer';

interface IDeleteConfirmationModalProps {
  entityToDelete?: string;
  hideModal: () => void;
  deleteFunction: () => void;
}

const DeleteConfirmationModal: React.FC<IDeleteConfirmationModalProps> = (
  props
) => {
  const { hideModal, deleteFunction, entityToDelete } = props;

  const deleteAction = (): void => {
    deleteFunction();
    hideModal();
  };

  return (
    <>
      <Modal hide={hideModal} canClickOutside={true} isNarrow={true}>
        <ListViewContainer
          title="Warning"
          rejectedMessage={undefined}
          close={hideModal}
        >
          <Box>
            <P color="NegativeChange">
              {`Are you sure you want to delete this ${
                entityToDelete ? entityToDelete : 'region'
              }?`}
            </P>
          </Box>

          <Box
            mt={'2em'}
            display="flex"
            justifyContent="flex-end"
            alignItems="flex-end"
            mb={'2em'}
          >
            <Button
              onClick={hideModal}
              variant={'secondary'}
              alignSelf="auto"
              fontWeight={600}
            >
              Cancel
            </Button>
            <Button
              fontWeight={600}
              variant={'destructive'}
              alignSelf="auto"
              marginLeft=".5em"
              onClick={deleteAction}
              data-gtag="custom-region-delete"
              data-pw="custom-region-dialog-confirmation-delete-btn"
            >
              Delete
            </Button>
          </Box>
        </ListViewContainer>
      </Modal>
    </>
  );
};

export default DeleteConfirmationModal;
